import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commonDate',
    standalone: true,
    pure: true
})
export class CommonDatePipe implements PipeTransform {
    transform(value: string | number | Date | null | undefined): string {
        if (!value) {
            return '';
        }

        try {
            return formatDate(value, 'dd-MM-yyyy', 'en-US');
        } catch {
            return '';
        }
    }
}
